import axios from 'axios';
import { 
  getPendingChanges, 
  markChangeSynced,
  getPendingPhotos,
  markPhotoSynced 
} from './offlineStore';

class SyncManager {
  constructor() {
    this.syncing = false;
    this.syncCallbacks = [];
  }

  onSync(callback) {
    this.syncCallbacks.push(callback);
  }

  async sync() {
    if (this.syncing) {
      console.log('⏳ Sync läuft bereits...');
      return;
    }

    if (!navigator.onLine) {
      console.log('📡 Offline - Sync nicht möglich');
      return;
    }

    this.syncing = true;
    console.log('🔄 Starte Synchronisation...');

    try {
      await this.syncPendingChanges();
      await this.syncPendingPhotos();

      console.log('✅ Synchronisation erfolgreich');
      this.syncCallbacks.forEach(cb => cb({ success: true }));
      
    } catch (error) {
      console.error('❌ Sync-Fehler:', error);
      this.syncCallbacks.forEach(cb => cb({ success: false, error }));
    } finally {
      this.syncing = false;
    }
  }

  async syncPendingChanges() {
    const changes = await getPendingChanges();
    
    if (changes.length === 0) {
      console.log('📭 Keine ausstehenden Änderungen');
      return;
    }

    console.log(`📤 Synchronisiere ${changes.length} Änderungen...`);

    for (const change of changes) {
      try {
        const { url, method, body } = change.data;
        
        // Verwende aktuellen Token aus localStorage
        const token = localStorage.getItem('token');
        
        await axios({
          method: method,
          url: url,
          data: body,
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        await markChangeSynced(change.id);
        console.log('✓ Synced:', change.type, change.action);
        
      } catch (error) {
        console.error('Sync-Fehler für Change:', change.id, error.response?.data || error.message);
      }
    }
  }

  async syncPendingPhotos() {
    const photos = await getPendingPhotos();
    
    if (photos.length === 0) {
      console.log('📷 Keine ausstehenden Fotos');
      return;
    }

    console.log(`📤 Synchronisiere ${photos.length} Fotos...`);

    for (const photo of photos) {
      try {
        // Konvertiere Base64 zurück zu Blob
        const response = await fetch(photo.base64);
        const blob = await response.blob();
        
        const formData = new FormData();
        formData.append('file', blob, photo.filename);

        const token = localStorage.getItem('token');

        if (photo.todoId) {
          await axios.post(`/api/todos/${photo.todoId}/attachments`, formData, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'multipart/form-data'
            }
          });
        }

        await markPhotoSynced(photo.id);
        console.log('✓ Foto synced:', photo.filename);
        
      } catch (error) {
        console.error('Foto-Sync-Fehler:', photo.id, error);
      }
    }
  }
}

export const syncManager = new SyncManager();

window.addEventListener('online', () => {
  console.log('🟢 Online - starte Auto-Sync');
  setTimeout(() => syncManager.sync(), 1000);
});
